const useAgeGateInitialStates = () => {
  const ageGateInititalState = {
    completedAgeGate: false,
    rememberData: false,
  };
  return { ageGateInititalState };
};

export default useAgeGateInitialStates;
